import React from 'react';
import { useTable } from 'react-table';
import { FormatNumber2 } from '../../utility/component/tools';

const AMOUNT_FIELDS = ['SALE_PRICE', 'IAMOUNT', 'SAMOUNT', 'RAMOUNT'];

const IssueTable = ({ data, columns }) => {
  // const columns = c.filter((column, index) => index !== c.length);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <table
          style={{
            width: '100%',
            height: '500px',
          }}
          {...getTableProps()}
        >
          <thead style={{ height: '45px', width: '100%' }}>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    style={
                      columns.width
                        ? {
                            width: columns.width,
                            border: '1px solid black',
                            fontSize: '10px',
                          }
                        : {
                            flex: 1,
                            border: '1px solid black',
                          }
                    }
                    {...column.getHeaderProps()}
                  >
                    {column.renderHeader()}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody
            style={{ width: '100%', overflow: 'hidden', overflowY: 'Scroll' }}
            {...getTableBodyProps()}
          >
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr
                  style={{
                    height: '30px',
                    width: '100%',
                    pageBreakInside: 'avoid',
                    pageBreakAfter: 'auto',
                  }}
                  {...row.getRowProps()}
                >
                  {row.cells.map((cell) => {
                    const cellValue = cell.render('Cell');

                    const rawValue = cell.value;
                    const isAmount = AMOUNT_FIELDS.includes(cell.column.id);
                    const isNumericValue =
                      cell.column.align === 'right' ||
                      cell.column.type === 'number' ||
                      typeof rawValue === 'number';

                    const cellContent =
                      rawValue === 0 || rawValue === '' || rawValue == null
                        ? ''
                        : isAmount
                        ? FormatNumber2(rawValue)
                        : cellValue;

                    const rowWidth = cell.column.width;

                    const cellStyle = {
                      border: '1px dotted black',
                      fontSize: '12px',
                      textAlign: isNumericValue ? 'right' : 'left',
                      fontVariantNumeric: isNumericValue
                        ? 'tabular-nums'
                        : 'normal',
                      width: rowWidth,
                    };

                    return (
                      <td
                        className="pl-2 pr-3"
                        style={cellStyle}
                        {...cell.getCellProps()}
                      >
                        {cellContent}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IssueTable;
